import React, { useState, useEffect } from 'react'
import { DataForm, LoaderInfo } from '../../../../../libs/react-mpk/components'
import { number, utils } from '../../../../../libs/react-mpk/services'
import { storage } from '../../../../../services'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'

const generate = () => {
  let data = storage.generate(storage.keys.SPT_1770S_DETAIL_LAMP_IID, {
    daftarKeluarga:[]
  })

  return data
}

const { inputTypes } = DataForm
const DetailLampIID = (props) => {
  const [ready, setReady] = useState(false)
  const [defaultData, setDefaultData] = useState({})
  useEffect(() => {
    let defData = storage.get(storage.keys.SPT_1770S_DETAIL_LAMP_IID)
    setDefaultData(defData)
    setReady(true)
  }, [])

  return ready ? (
    <DataForm
      baseId="spt-1770S-header-lamp-IID"
      className="mpk-padding-NONE padding-all"
      style={{
        width: '100%',
        maxWidth: 800,
      }}
      asDialog={false}
      editable={props.isEditable}
      defaultData={defaultData}
      definitions={[
        {
          inputType: inputTypes.LIST,
          label: t.translate('column.daftarKeluarga'),
          key:'daftarKeluarga',
          defaultData: {
            nama: "",
            nik: "",
            hubungan: props.envStore.env.spt.HUBUNGAN[0].value,
            perkerjaan: ""
          },
          definitions:[
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770S.DetailLampIID.NAMA'),
              key: 'nama',
              required: true,
              validation: 'min:4',
              helpText: t.translate('sentence.minimumName'),
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770S.DetailLampIID.NIK'),
              key: 'nik',
              validation: 'digits:16',
              required: true
            },
            {
              inputType: inputTypes.SELECT,
              label: t.translate('modules.submission.sptForm.1770S.DetailLampIID.HUBUNGAN'),
              key: 'hubungan',
              options: props.envStore.env.spt.HUBUNGAN,
              required: true
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770S.DetailLampIID.PEKERJAAN'),
              key: 'pekerjaan',
              required: true
            }
          ]
        }
      ]}
      onBeforeChange={(key, value) => (
          ['nik'].indexOf(key) >= 0 
            ? value.replace(/\D/g, '')
            : value
      )}
      onSubmit={(data, callback) => {
        let isDuplicate = utils.isDuplicateObjectInArray(data.daftarKeluarga, ['nik'])

        if(isDuplicate){
          callback(new Error(t.translate('sentence.duplicateKeluarga')))
        } else {
          props.onSave(storage.keys.SPT_1770S_DETAIL_LAMP_IID, data)
          callback(t.translate('sentence.savedItem'), false)
        }
      }}
      submitLabel={t.translate('column.save')}
    />
  ) : <LoaderInfo/>
}

DetailLampIID.generate = generate

export default inject('envStore')(observer(DetailLampIID))
